/* tslint:disable */
/* eslint-disable */
/**
 * Survey API
 * API for managing Surveys and Questions.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { QuestionOrderDto } from './QuestionOrderDto';
import {
    QuestionOrderDtoFromJSON,
    QuestionOrderDtoFromJSONTyped,
    QuestionOrderDtoToJSON,
    QuestionOrderDtoToJSONTyped,
} from './QuestionOrderDto';

/**
 * 
 * @export
 * @interface ReorderQuestionsCommand
 */
export interface ReorderQuestionsCommand {
    /**
     * Questionnaire ID
     * @type {string}
     * @memberof ReorderQuestionsCommand
     */
    questionnaireId: string;
    /**
     * List of questions with their new order
     * @type {Array<QuestionOrderDto>}
     * @memberof ReorderQuestionsCommand
     */
    questions: Array<QuestionOrderDto>;
}

/**
 * Check if a given object implements the ReorderQuestionsCommand interface.
 */
export function instanceOfReorderQuestionsCommand(value: object): value is ReorderQuestionsCommand {
    if (!('questionnaireId' in value) || value['questionnaireId'] === undefined) return false;
    if (!('questions' in value) || value['questions'] === undefined) return false;
    return true;
}

export function ReorderQuestionsCommandFromJSON(json: any): ReorderQuestionsCommand {
    return ReorderQuestionsCommandFromJSONTyped(json, false);
}

export function ReorderQuestionsCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReorderQuestionsCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'questionnaireId': json['questionnaireId'],
        'questions': ((json['questions'] as Array<any>).map(QuestionOrderDtoFromJSON)),
    };
}

export function ReorderQuestionsCommandToJSON(json: any): ReorderQuestionsCommand {
    return ReorderQuestionsCommandToJSONTyped(json, false);
}

export function ReorderQuestionsCommandToJSONTyped(value?: ReorderQuestionsCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'questionnaireId': value['questionnaireId'],
        'questions': ((value['questions'] as Array<any>).map(QuestionOrderDtoToJSON)),
    };
}

